import { Divider, Stack, Typography } from "@mui/material";
import { TierMapper } from "../../types/genereal";
import { TierType } from "../../types/enums";
import { RecommendedAccount } from "../../types/apiTypes";
import { useRef, useState } from "react";
import { ShowAllAccountsBlock } from "./ShowAllAccountsBlock";
import { RecommendedAccountCard } from "./RecommendedAccountCard";

const demoList = [
  {
    id: "1",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
  {
    id: "2",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
  {
    id: "3",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
  {
    id: "4",
    campaign_id: "1",
    name: "--",
    industry: "--",
    region: "--",
    size: "--",
    revenue: "--",
    tier: TierType.medium,
    reason: "--",
  },
];

type Props = {
  tier: TierType;
  recommendedAccounts: RecommendedAccount[];
  isDemo: boolean;
};

export const RecommendedGridList = ({
  tier,
  recommendedAccounts,
  isDemo,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  const { label, title, color } = TierMapper[tier];

  if (recommendedAccounts.length === 0 && !isDemo) return null;
  return (
    <Stack gap={"16px"}>
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        {isDemo ? (
          <>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "19px",
                color: "#9B9B9B",
                textWrap: "nowrap",
              }}
            >
              Tier
            </Typography>
            <Divider
              sx={{
                marginX: "8px",
                width: "100%",
                borderColor: "#9B9B9B",
                borderBottomWidth: "4px",
                flexShrink: 1,
              }}
            />
          </>
        ) : (
          <>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "19px",
                color: color,
                textWrap: "nowrap",
              }}
            >
              {label} - {title}
            </Typography>
            <Divider
              sx={{
                marginX: "8px",
                width: "100%",
                borderColor: color,
                borderBottomWidth: "4px",
                flexShrink: 1,
              }}
            />
            {recommendedAccounts.length > 4 && (
              <div
                style={{
                  paddingLeft: "12px",
                }}
              >
                <ShowAllAccountsBlock
                  isStartIcon={false}
                  isExpanded={isExpanded}
                  total={recommendedAccounts.length}
                  expandHandler={() => setIsExpanded((prev) => !prev)}
                />
              </div>
            )}
          </>
        )}
      </Stack>
      <Stack
        ref={ref}
        sx={{
          width: "100%",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        {(isDemo ? demoList : recommendedAccounts)
          .slice(0, isExpanded ? undefined : 4)
          .map((account) => (
            <RecommendedAccountCard
              key={account.id}
              recommendedAccount={account}
              isDemo={isDemo}
            />
          ))}
      </Stack>
    </Stack>
  );
};
